import { BaseEntity } from '../baseEntity';
import { Member } from '../organisation';
import { SearchExecution } from '../search/searchExecution';

export enum VoteType {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
}

export interface TenderVote extends BaseEntity {
  searchExecution: SearchExecution;
  type: VoteType;
  reason: string;
  voter: Member;
}
